var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v18H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v18H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.773 4.227a6.75 6.75 0 11-9.546 9.546 6.75 6.75 0 019.546-9.546zm-.597.597a5.905 5.905 0 00-8.352 0 5.905 5.905 0 000 8.352 5.905 5.905 0 008.352 0 5.905 5.905 0 000-8.352zm-2.91 6.285a.422.422 0 010 .844h-.422c-.7 0-1.266-.567-1.266-1.265v-2.11h-.422a.422.422 0 010-.844h.422c.466 0 .844.378.844.844v2.11c0 .232.189.421.422.421h.422zm-.844-4.851a.632.632 0 11-1.265.001.632.632 0 011.265-.001z",
    fill: "#fff",
    fillRule: "nonzero"
  }))));
}
export default SvgCountryInfo;